<template>
    <div v-if="isFullscreen"
         class="fullscreen-overlay"
         @click="toggleFullscreen">
    </div>
	  <div id="preview mt-1" style="margin-top:5px;" v-if="selectedArticle">
		<div :class="['fullscreen-wrapper', { fullscreen: isFullscreen }]">
		  <div class="d-flex justify-content-between align-items-center"
			   :style="{
				 padding: isFullscreen ? '.5rem' : '.1rem',
				 marginBottom: isFullscreen ? '5px' : '0',
				 backgroundColor: isFullscreen ? 'grey' : 'white',
				 position: isFullscreen ? 'sticky' : 'static',
				 zIndex: isFullscreen ? '99999' : '0',
				 top: isFullscreen ? '0' : null
			   }">
			
			<!-- Tytuł po lewej -->
			<h6 class="mb-0" :style="{color: isFullscreen ? 'white' : 'inherit'}">
			  Szczegóły artykułu {{ selectedArticle.catalog_number }} - {{ selectedArticle.model }}
			</h6>

			<!-- Przycisk po prawej -->
			<button class="btn btn-sm" 
					:class="{'btn-outline-primary': !isFullscreen}" 
					@click="toggleFullscreen">
			  <i :class="isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'"></i>
			  <span class="ms-2">
				{{ isFullscreen ? 'Wyjdź z trybu pełnego ekranu' : 'Pełny ekran' }}
			  </span>
			</button>

		  </div>

		  <!-- Reszta treści, np. wykresy -->
		  <template v-if="hasPermission('canViewArticlesPricesAndHistory')">
			<div class="widget-content" v-if="series.length > 0">
			  <VueApexCharts height="400" type="line" :options="chartOptions" :series="series"></VueApexCharts>
			</div>
			<div class="widget-content" v-else>
			  Brak historycznych cen dla tego produktu.
			</div>
		  </template>
		</div>
	  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";

const {hasPermission} = usePermission();
export default {
  components: {VueApexCharts, hasPermission},
  props: {
    selectedArticle: Object,
	    currencys: {
        type: Array,
        default: () => []
    }
  },

  data() {
    return {
      hasPermission,
      articleHistory: null,
      chartOptions: {},
	  isFullscreen: false,
      series: []
    }
  },

  watch: {
    selectedArticle: {
      immediate: true,
      handler(newArticle) {
        if (newArticle) {
          this.getHistoryData(newArticle.id);
        }
      }
    }
  },

  methods: {
getCurrencyName(currency) {

    if (currency) {

        if (typeof currency === 'object' && currency.name) {
            return currency.name.toUpperCase();
        }

        if (this.currencys && Array.isArray(this.currencys)) {
            const found = this.currencys.find(c => c.id == currency);

            if (found) {
                return found.name.toUpperCase();
            }
        }
    }


    // jeżeli brak waluty - weź ostatnią znaną z historii
    if (this.articleHistory?.length) {

        const lastCurrency = [...this.articleHistory]
            .reverse()
            .find(x => x.currency);

        if (lastCurrency) {
            return this.getCurrencyName(lastCurrency.currency);
        }
    }


    return 'PLN';
},

      toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;

      // opcjonalnie blokada scrolla dokumentu
      document.body.style.overflow = this.isFullscreen ? 'hidden' : '';
    },
    getHistoryData() {
      axios.get(route('articles.getHistory', {article: this.selectedArticle.id})).then(response => {
        // dodaj selected Article do danych
        this.articleHistory = [this.selectedArticle];

        // dodaj dane historyczne
        this.articleHistory.push(...response.data.history);

        if (this.articleHistory.length > 0) {
          this.preparePrices();
        }
      }).catch(error => {
        console.log(error);
      });
    },

preparePrices() {

  const pricesNettoZl = this.articleHistory
      .map(item => parseFloat(item.price_netto_zl) || 0)
      .reverse();

  const pricesBruttoZl = this.articleHistory
      .map(item => parseFloat(item.price_brutto_zl) || 0)
      .reverse();


  const pricesNettoCurrency = this.articleHistory
      .map(item => parseFloat(item.price_netto) || 0)
      .reverse();

  const pricesBruttoCurrency = this.articleHistory
      .map(item => parseFloat(item.price_brutto) || 0)
      .reverse();


  const createdDates = this.articleHistory
      .map(item => this.formatDate(item.updated_at ?? item.created_at))
      .reverse();

  this.series = [
    {
      name: 'Netto PLN',
      data: pricesNettoZl,
    },
    {
      name: 'Brutto PLN',
      data: pricesBruttoZl,
    },
	{
	  name: 'Netto waluta',
	  data: pricesNettoCurrency
	},
	{
	  name: 'Brutto waluta',
	  data: pricesBruttoCurrency
	}
  ];
      this.chartOptions = {
        chart: {
          type: 'line',
          toolbar: {
            show: true,
            export: {
              csv: {
                filename: `${this.selectedArticle.catalog_number}-Historia cen`
              },
              png: {
                filename: `${this.selectedArticle.catalog_number}-Historia cen`
              },
              svg: {
                filename: `${this.selectedArticle.catalog_number}-Historia cen`
              }
            }
          }
        },
        stroke: {
          width: 2,

        },
        xaxis: {
          categories: createdDates,
          title: {
            text: 'Data'
          },
        },
tooltip: {
  shared: true,
  intersect: false,
  custom: ({series, dataPointIndex}) => {

    const item = [...this.articleHistory].reverse()[dataPointIndex];

    const currency = this.getCurrencyName(item?.currency);

    return `
      <div class="px-2">
        <div>Data: ${this.formatDate(item.updated_at ?? item.created_at)}</div>
        <div>Netto PLN: ${series[0][dataPointIndex]}</div>
        <div>Brutto PLN: ${series[1][dataPointIndex]}</div>
        <div>Netto ${currency}: ${series[2][dataPointIndex]}</div>
        <div>Brutto ${currency}: ${series[3][dataPointIndex]}</div>
      </div>
    `;
  }
},
        yaxis: {
          title: {
            text: 'Cena'
          }
        },
        title: {
          text: 'Ceny historyczne',
          align: 'center'
        }
      };
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Miesiące są od 0 do 11, więc dodajemy 1
      const year = date.getFullYear();

      return `${day}.${month}.${year}`;
    }
  }
}
</script>
<style scoped>

/* Główny wrapper komponentu */
.fullscreen-wrapper {
  position: relative;
  transition: all .3s ease-in-out;
}

/* Tryb pełnoekranowy */
.fullscreen-wrapper.fullscreen {
  position: fixed;
  z-index: 1050;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  padding: 20px;
  background: #ffffff;
  overflow: auto;
  box-shadow: 0 0 40px rgba(0,0,0,.25);
  animation: fadeInFullscreen .2s ease-in-out;
}

/* Przyciemnione tło */
.fullscreen-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 1049;
}

/* Delikatna animacja wejścia */
@keyframes fadeInFullscreen {
  from {
    opacity: 0;
    transform: scale(.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

</style>